"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeadSnippet = exports.getBodySnippet = void 0;
var _require = require('./tracking-service-integrations/gtm-service-integration'),
  getHtmlHeadSnippet = _require.getHeadSnippet,
  getHtmlBodySnippet = _require.getBodySnippet;
var getBodySnippet = function getBodySnippet() {
  var result = '';

  // Calling out to env variables
  var htmlSnippet = getHtmlBodySnippet();
  if (htmlSnippet.length > 0) {
    result += htmlSnippet;
  }
  return result;
};
exports.getBodySnippet = getBodySnippet;
var getHeadSnippet = function getHeadSnippet() {
  var result = '';

  // Calling out to env variables
  var htmlSnippet = getHtmlHeadSnippet();
  if (htmlSnippet.length > 0) {
    result += htmlSnippet;
  }
  return result;
};
exports.getHeadSnippet = getHeadSnippet;